/**
 * Center the active tab within a horizontal overflow container (curriculum tab strips).
 */
export function scrollHorizontalStripToActiveTab(
  container: HTMLElement | null,
  activeTabSelector = '[role="tab"][data-state="active"]',
): void {
  if (!container) return;
  const activeTrigger = container.querySelector<HTMLElement>(activeTabSelector);
  if (!activeTrigger) return;
  const cr = container.getBoundingClientRect();
  const tr = activeTrigger.getBoundingClientRect();
  const delta = tr.left + tr.width / 2 - (cr.left + cr.width / 2);
  const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
  const nextLeft = Math.max(0, Math.min(maxScroll, container.scrollLeft + delta));
  container.scrollTo({ left: nextLeft, behavior: "smooth" });
}

/** Run after Radix has applied active tab state. */
export function scheduleScrollHorizontalStripToActiveTab(
  container: HTMLElement | null,
  activeTabSelector = '[role="tab"][data-state="active"]',
  onComplete?: () => void,
): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollHorizontalStripToActiveTab(container, activeTabSelector);
      onComplete?.();
    });
  });
}
